import React, { useMemo } from 'react';

import { Form } from '@unform/web';
import { parseISO, format } from 'date-fns';
import PropTypes from 'prop-types';

import { number } from '~/helpers';
import { DateTime, Input, Select } from '~/components/Form';
import * as S from './styles';

export default function Details({ data, visible }) {
  const status = useMemo(
    () => [
      { label: 'AGUARDANDO RECEBIMENTO ', value: 0 },
      { label: 'RECEBIMENTO INICIADO', value: 1 },
      { label: 'RECEBIMENTO FINALIZADO', value: 2 },
      { label: 'CANCELADA', value: 3 },
    ],
    []
  );

  if (visible)
    return (
      <Form
        onSubmit={undefined}
        initialData={{
          ...data,
          nfre_data_recebimento: format(
            parseISO(data.nfre_data_recebimento),
            'dd/MM/yyyy HH:mm'
          ),
          desc_dt_emissao_nf: format(
            parseISO(data.desc_dt_emissao_nf),
            'dd/MM/yyyy HH:mm'
          ),
          desc_volume_nf: number(data.desc_volume_nf, 0),
        }}
      >
        <S.Wrapper>
          <DateTime
            time
            disabled
            name="nfre_data_recebimento"
            label="Data Recebimento"
          />

          <Input
            disabled
            name="nfre_numero"
            label="Nota Fiscal"
            type="number"
          />

          <Input
            disabled
            name="nfre_chave"
            label="Chave Eletrônica"
            type="number"
          />

          <Select disabled name="nfre_status" label="Status" options={status} />

          <Input disabled name="post_desc" label="Posto" />

          <Input disabled name="desc_placa_ct" label="Placa CT" />

          <Input
            disabled
            name="desc_distribuidora"
            label="CNPJ Distribuidora"
          />

          <Input disabled name="desc_volume_nf" label="Volume" />

          <DateTime
            time
            disabled
            name="desc_dt_emissao_nf"
            label="Data Emissão"
          />
        </S.Wrapper>
      </Form>
    );

  return <div />;
}

Details.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  visible: PropTypes.bool.isRequired,
};
